module.exports = __webpack_public_path__ + "img/673B2A_99735C_99593A_3A160E-256px.9c01d5c1.png";